import { APP_NAME } from '../constant'

const en = {
  'i0001': 'This is english text',
  'i0002': 'Home',
  'i0003': 'About Us',
  'i0004': 'Test',
}
export default en